import { WorkflowModuleSurfaceRegistry } from './workflow-module-surface.registry';
import { registerGrowthWorkflowSurfaces } from './growth.workflow-surfaces';
import { registerRouteBasedWorkflowSurfaces } from './route-based.workflow-surfaces';
import { Router } from '@angular/router';

export function registerPlatformTestWorkflowSurfaces(registry: WorkflowModuleSurfaceRegistry): void {
  registry.register({
    moduleKey: 'platform',
    surfaceKey: 'platform.test.surface',
    titleKey: 'workflow.surfaces.test.title',
    descriptionKey: 'workflow.surfaces.test.description',
    loadComponent: () =>
      import('./workflow-test-surface.component').then(module => module.WorkflowTestSurfaceComponent)
  });
}

export function registerAllWorkflowModuleSurfaces(registry: WorkflowModuleSurfaceRegistry, router: Router): void {
  registerPlatformTestWorkflowSurfaces(registry);
  registerGrowthWorkflowSurfaces(registry);
  registerRouteBasedWorkflowSurfaces(registry, router);
}
